import { render, staticRenderFns } from "./SmallTable.vue?vue&type=template&id=29b3d0b6&scoped=true&"
import script from "./SmallTable.vue?vue&type=script&lang=js&"
export * from "./SmallTable.vue?vue&type=script&lang=js&"
import style0 from "./SmallTable.vue?vue&type=style&index=0&id=29b3d0b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b3d0b6",
  null
  
)

export default component.exports